import { render, staticRenderFns } from "./CreateCalendarPage.vue?vue&type=template&id=6a1ec4fc&scoped=true"
import script from "./CreateCalendarPage.vue?vue&type=script&lang=js"
export * from "./CreateCalendarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ec4fc",
  null
  
)

export default component.exports